import { type INavigationStore, Screens } from "../../../stores/navigation";
import type { WarehouseStatsCardKey } from "../components/WarehouseStats/WarehouseStats";

export function openStatsListByKey(
  navigationStore: INavigationStore,
  key: WarehouseStatsCardKey,
): void {
  if (key === "users") {
    navigationStore.setScreen(Screens.UsersManagement);
    return;
  }

  if (key === "deleted") {
    navigationStore.setScreen(Screens.DeletedEntities);
    return;
  }

  if (key === "boxesTotal") {
    navigationStore.setScreen(Screens.BoxesList, {
      title: "Список коробок",
    });
    return;
  }

  if (key === "productsInBoxes") {
    navigationStore.setScreen(Screens.ProductsList, {
      title: "Товары в коробках",
      placement: "inBox",
    });
    return;
  }

  if (key === "productsWithoutBox") {
    navigationStore.setScreen(Screens.ProductsList, {
      title: "Товары без коробки",
      placement: "withoutBox",
    });
    return;
  }

  if (key === "expiringSoon") {
    navigationStore.setScreen(Screens.ProductsList, {
      title: "Товары с истекающим сроком",
      expiry: "expiringSoon",
      expiringDays: 7,
    });
    return;
  }

  if (key === "expired") {
    navigationStore.setScreen(Screens.ProductsList, {
      title: "Просроченные товары",
      expiry: "expired",
    });
    return;
  }

  navigationStore.setScreen(Screens.ProductsList, {
    title: "Список товаров",
  });
}
